namespace SP {
    export interface StockUnit {
        id: string;
        stockSectionId: string;
        stockUnitTypeId: string;
        number: number;
        gridX: number;
        gridY: number;
        rotation: number;
        itemSize: number;
    }
}